export const metricsRouteName = 'dashboard.metrics';
// Pre-Grafana-rename alias kept alive for older links. It only redirects to `metricsRouteName`.
export const grafanaStateName = 'dashboard.grafana';
